export default __webpack_public_path__ + "static/media/avatar_bg_sakura.462e8de4.png";